export default (hit, isInit) => {
  return `
  <a onclick="_paq.push(['trackEvent', 'engages-passionnes', 'engagements', 'Voir l'engagement']);" href="${hit.path}" class="card card--${hit.tag && hit.tag.length > 0 ? hit.tag[0] : 'no-tag'} bg-white text-indigo-blue" ${isInit ? 'js-scroll-animations-target' : ''}>
    <div class="card__picto rounded-top-right">
        <svg width="24" height="21" class="icon--white">
            <use href="#icon-commitment" xlink:href="#icon-commitment" />
        </svg>
    </div>

    <p class="font-cursive text-56 tracking-tighter text-center pb-8 -mt-3">${config.trads.commitment}</p>

    <div>
        <div class="flex flex-wrap items-center mb-4">
            ${hit.tag
              ? hit.pillarName.map((tag, i) => {
                return (
                  `<span class="tag tag--${hit.tag[i]} mb-2 ${i !== hit.tag.length - 1 ? 'mr-1' : 'mr-4'}">${tag}</span>`
                )
              }).join('')
              : ''
            }

            ${hit.grade && hit.grade !== 0
              ? `<div class="flex mb-2">
                  ${Array(5).fill().map((item, i) => {
                    return (
                      `<svg width="12" height="16" class="card__drop ${i >= hit.grade ? 'opacity-40' : ''}">
                          <use href="#icon-drop" xlink:href="#icon-drop" />
                      </svg>`
                    )
                  }).join('')}
                </div>`
              : ''
            }
        </div>

        <p class="title title--3-bigger-mobile title--semibold mb-3">${hit.title}</p>
              
        ${hit.chapo
          ? `<p class="card__txt">${hit.chapo}</p>`
          : ''
        }

        <span class="cta cta--icon mt-5">
          ${config.trads['commitment.see']}
            <svg width="13" height="10" class="icon--indigo-blue">
                <use href="#icon-arrow-right" xlink:href="#icon-arrow-right" />
            </svg>
        </span>
    </div>
  </a>
  `
}
